import React from 'react';
import { Container, Title, Idea, ContainerFluid, Images, Text } from './InstitucionalStyles';

import InfraSlider from 'src/components/InfraSlider';

const Institution =  ({
    title, subtitle, description,
    img01, img02, img03, slides
}) => {

    const deafultSlides = [];

    if(slides){
        for( const slide in slides){
            if(slides[slide]){
                deafultSlides.push(slides[slide]);
            }
        }
    }
    else{
        deafultSlides.push(img01);
    }

    return (
        <>
            <Container>
                <Title dangerouslySetInnerHTML={{__html: title}} />
            
                <Idea dangerouslySetInnerHTML={{__html: subtitle}} />
            </Container>

            <ContainerFluid>
                <Images>
                    <img src={img01} alt="Hipermercado das Rações"/>
                    <img src={img02} alt="Hipermercado das Rações"/>
                    <img src={img03} alt="Hipermercado das Rações"/>
                </Images>

                <Text dangerouslySetInnerHTML={{__html: description}} />
            </ContainerFluid>

            <InfraSlider mt={-30} images={deafultSlides}/>
        </>
    )
}

export default Institution;